import {connect} from 'react-redux';
import {ProtocolTableActual as Component} from './ProtocolTableActual';
// import {} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    tableData: state.notebook.protocolSection.tableData
  }
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const ProtocolTableActual = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
